import { render, staticRenderFns } from "./ReportesLectorBusqueda.vue?vue&type=template&id=3b96a974&"
import script from "./ReportesLectorBusqueda.vue?vue&type=script&lang=js&"
export * from "./ReportesLectorBusqueda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports